<template>
  <page-outline :title="listTitle">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <!-- Bouton de rafraîchissement -->
        <b-row class="justify-content-start">
          <b-col cols="4" lg="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" class="mb-5">
            <b-button class="btnFilter"
              @click="displayFilter = !displayFilter">
              <i v-if="displayFilter" class="fa-light fa-minus"></i>
              <i v-else class="fa-light fa-plus"></i>
              {{ $t('filter.fltr') }}
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" class="mb-5">
            <b-button
              class="btnFilter"
              :disabled="activateSpinner"
              @click="onRefresh()">
              <i class="fa-light fa-rotate-right fs-14px"></i>
              {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
          <div>
            <b-button variant="secondary"
              @click="actionAdd">
              <i class="fa-light fa-plus"></i>
              <span>{{$t('common.bic.bic_add')}}</span>
            </b-button>
          </div>
        </b-row>
        <b-row class="justify-content-start align-items-center mb-5" :class="{'filter-item-section':true, 'd-none': !displayFilter}">
          <b-col sm="3" class="form-group">
          <!-- Filtre BicCode -->
            <form-write-group-label-input v-model="BicCode"
              :inputLabel="$t('common.bic.bic_code')"
              @input="applyFilter">
            </form-write-group-label-input>
          </b-col>
          <!-- Boutons Effacer et Appliquer -->
          <b-col sm="2" class="d-flex justify-content-end">
            <b-button class="btn mr-3" size="sm"
              @click="clearFilterFields"
              :disabled="!BicCode">
              {{ $t('filter.clr_fltr_field') }}
            </b-button>
            <!-- <b-button class="btn" size="sm"
              @click="applyFilter">
              {{ $t('common.srch') }}
            </b-button> -->
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-5">
          <div>
            <spinner v-if="activateSpinner"></spinner>
            <b-table v-else-if="listItemsBic.length > 0"
              :items="listItemsBic"
              :fields="fields"
              :sort-by.sync="sortBy"
              class="table-striped"
              fixed
              hover
              :selectable="listItemsBic.length > 0"
              :empty-text="$t('common.security.no_result')"
              @row-selected="onRowSelected"
              :key="refreshKey">
              <template #cell(BicCode)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(edit)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="actionEdit($event, data.item.IdBic)">
                  <i class="fa-regular fa-pencil"></i>
                </span>
              </template>
              <template #cell(delete)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="actionDelete($event, data.item.IdBic)">
                  <i class="fa-regular fa-trash"></i>
                </span>
              </template>
            </b-table>
            <div v-else class="d-flex justify-content-center">
              <span class="noResult">
                {{ $t('common.no_result') }}
              </span>
            </div>
          </div>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"
import backButton from "@/components/common/backButton.vue"

export default {
  name: "BicPage",
  components: {
    'back-button': backButton,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    spinner: Spinner
  },
  props: {
    id: {
      type: String,
      default: "-1",
    },
  },
  data() {
    return {
      activateSpinner: false,
      BicCode: '',
      displayFilter: false,
      elementSearchedBic: '',
      listItemsBic: [],
      listTitle: "",
      refreshKey: false,
      returnUrl: '/bic/bicGroup/-1',
      sortBy: 'BicCode'
    }
  },
  created() {
    this.activateSpinner = true

    const bicGroupId = this.$route.params.id

    this.getGroupName(bicGroupId).then(groupName => {
      this.listTitle = `${this.$i18n.t("common.bic.bic_list")} - ${groupName}`;
      this.getBic(bicGroupId);
    })
  },
  computed: {
    canDelete () {
      return true
    },
    canEdit () {
      return true
    },
    fields () {
      let fields = []

      // fields.push({
      //   key: 'IdBic',
      //   label: this.$t('IdAdd'),
      //   thClass: 'text-center table-condensed-ipad',
      //   tdClass: 'p-0 text-center w-100 p-2 py-3',
      //   sortable: true
      // })
      fields.push({
        key: 'BicCode',
        label: this.$t('common.bic.bic_code'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      // fields.push({
      //   key: 'IdBicGroup',
      //   label: this.$t('IdGroup'),
      //   thClass: 'text-center table-condensed-ipad',
      //   tdClass: 'p-0 text-center w-100 p-2 py-3',
      //   sortable: true
      // })
      // fields.push({
      //   key: 'GroupName',
      //   label: this.$t('common.bic.group_name'),
      //   thClass: 'text-center table-condensed-ipad',
      //   tdClass: 'p-0 text-center w-100 p-2 py-3',
      //   sortable: true
      // })
      if (this.canEdit) {
        fields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
      }
      if (this.canDelete) {
        fields.push({ key: 'delete', label: this.$t('rights.delete'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
      }
      return fields
    }
  },
  methods: {
    actionAdd () {
      const bicGroupId = this.$route.params.id
      loadPage(this, {url: '/bic/bic/add/-1' + '?groupId=' + bicGroupId })
    },
    actionDelete ($e, id) {
      $e.stopPropagation()
      let that = this
      const bicGroupId = this.$route.params.id
      this.$f7.modal({
        title: this.$t('common.bic.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = { id: id }
              that.$engine.bic.bic.delete(params)
              .then(resp => {
                that.listItemsBic = that.listItemsBic.filter(item => item.IdBic !== id)
                that.$f7.modal({
                  title: that.$t('common.bic.bic_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, { url: 'bic/bic/' + bicGroupId })
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.bic.bic_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () { return }
          }
        ]
      })
    },
    actionEdit ($e, id) {
      $e.stopPropagation()
      const bicGroupId = this.$route.params.id
      loadPage(this, { url: '/bic/bic/edit/' + id + '?groupId=' + bicGroupId })
    },
    applyFilter () {
      this.activateSpinner = true
      this.getBic()
    },
    clearFilterFields () {
      this.BicCode = ''
      // this.applyFilter()
    },
    getBic (bicGroupId) {
      let that = this
      let params = { groupId: bicGroupId, BicCode: this.BicCode }
      this.$engine.bic.bic.fetch(params).then((resp) => {
        let bicList = {}

        bicList = resp.data.Bic

        for (let i = 0; i < bicList.length; i++) {
          bicList[i].delete = bicList[i].IdBic
          bicList[i].edit = bicList[i].IdBic
        }

        that.updateBic(bicList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getGroupName (bicGroupId) {
      return this.$engine.bic.bicGroup.fetch({ id: bicGroupId }).then(resp => {
        const group = resp.data.BicGroup.find(group => group.IdBicGroup === bicGroupId)
        return group ? group.GroupName : null
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onRefresh () {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      const bicGroupId = this.$route.params.id
      this.getBic(bicGroupId)
    },
    onRowSelected (item) {
      if (item[0] && item[0].IdBic) {
        const bicGroupId = this.$route.params.id
        loadPage(this, { url: '/bic/bic/details/' + item[0].IdBic + '?groupId=' + bicGroupId })
      }
    },
    updateBic (bicList) {
      this.listItemsBic = bicList.filter(item => item.IdBicGroup === this.$route.params.id)
    }
  }
}
</script>
